// toastService.ts
export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastPayload {
    message: string;
    type?: ToastType;
    duration?: number;
    path?: string;
    desc?: string;
    id?: string;
}

export const showToast = (payload: ToastPayload) => {
    const event = new CustomEvent('app-toast', {
        detail: payload,
    });
    window.dispatchEvent(event);
};
